// 模擬 Google Places API。
// 因為 demo 階段沒有後端也沒有申請 Google API Key，
// 這裡用一份固定的假資料取代「搜尋地點」的網路請求，
// 之後若要接上真的 Google Places API，只需要替換 searchMockPlaces() 的實作即可，
// 呼叫方（PlaceSearchDialog.vue）不需要更動。
const MOCK_PLACE_DB = [
  { placeId: 'mock-koffee-mameya', name: 'Koffee Mameya', category: 'coffee', address: '東京都渋谷区神宮前4-15-3', lat: 35.6690, lng: 139.7076 },
  { placeId: 'mock-fuglen-tokyo', name: 'Fuglen Tokyo', category: 'coffee', address: '東京都渋谷区富ヶ谷1-16-11', lat: 35.6685, lng: 139.6821 },
  { placeId: 'mock-glitch-coffee', name: 'Glitch Coffee', category: 'coffee', address: '東京都千代田区神田錦町3-16', lat: 35.6944, lng: 139.7580 },
  { placeId: 'mock-teamlab', name: 'teamLab Planets', category: 'attraction', address: '東京都江東区豊洲6-1-16', lat: 35.6465, lng: 139.7930 },
  { placeId: 'mock-tsukiji', name: '築地場外市場', category: 'attraction', address: '東京都中央区築地4丁目', lat: 35.6654, lng: 139.7707 },
  { placeId: 'mock-shibuya-sky', name: 'Shibuya Sky', category: 'attraction', address: '東京都渋谷区渋谷2-24-12', lat: 35.6585, lng: 139.7016 },
  { placeId: 'mock-yakitori-omino', name: 'やきとり おみの', category: 'food', address: '東京都新宿区歌舞伎町1-1-10', lat: 35.6944, lng: 139.7028 },
  { placeId: 'mock-ichiran', name: '一蘭 渋谷店', category: 'food', address: '東京都渋谷区宇田川町', lat: 35.6598, lng: 139.6994 },
  { placeId: 'mock-daikanyama-tsite', name: '代官山蔦屋書店', category: 'shopping', address: '東京都渋谷区猿楽町17-5', lat: 35.6484, lng: 139.6980 },
  { placeId: 'mock-shimokitazawa', name: '下北澤古著街', category: 'shopping', address: '東京都世田谷区北沢2丁目', lat: 35.6613, lng: 139.6683 },
  { placeId: 'mock-kamakura', name: '鎌倉高校前', category: 'attraction', address: '神奈川県鎌倉市腰越', lat: 35.3059, lng: 139.5013 },
  { placeId: 'mock-hakone', name: '箱根神社', category: 'attraction', address: '神奈川県足柄下郡箱根町元箱根80-1', lat: 35.2020, lng: 139.0246 },
  { placeId: 'mock-park-hyatt', name: 'Park Hyatt Tokyo', category: 'lodging', address: '東京都新宿区西新宿3-7-1-2', lat: 35.6859, lng: 139.6907 },
  { placeId: 'mock-tokyo-station-hotel', name: 'The Tokyo Station Hotel', category: 'lodging', address: '東京都千代田区丸の内1-9-1', lat: 35.6812, lng: 139.7671 },
  { placeId: 'mock-monja-street', name: '月島もんじゃストリート', category: 'food', address: '東京都中央区月島西仲通り', lat: 35.6636, lng: 139.7830 },
  { placeId: 'mock-narita-airport', name: '成田國際機場', category: 'transport', address: '千葉県成田市', lat: 35.7720, lng: 140.3929 }
]

export const PLACE_CATEGORY_LABELS = {
  attraction: '景點',
  food: '餐廳',
  coffee: '咖啡',
  shopping: '購物',
  lodging: '住宿',
  transport: '交通',
  other: '其他'
}

export function searchMockPlaces (keyword) {
  const kw = (keyword || '').trim().toLowerCase()
  if (!kw) return []
  return MOCK_PLACE_DB.filter(p =>
    p.name.toLowerCase().includes(kw) || p.address.toLowerCase().includes(kw)
  )
}

// 模擬「貼上 Google Maps 連結」：
// 真正的 Google Maps 短連結需要伺服器展開＋解析，demo 階段用關鍵字比對假資料庫，
// 找不到符合的地點時，回傳一筆「手動圖釘」資料（沒有 placeId，座標給東京車站附近的隨機值）。
export function parseMockMapsLink (link) {
  const kw = (link || '').split(/[/?]/).filter(Boolean).pop() || ''
  const matched = searchMockPlaces(decodeURIComponent(kw).replace(/[+-]/g, ' '))
  if (matched.length) return matched[0]
  return {
    placeId: null,
    name: '未命名地點（由連結貼上）',
    category: 'other',
    address: link,
    lat: 35.681236 + (Math.random() - 0.5) * 0.05,
    lng: 139.767125 + (Math.random() - 0.5) * 0.05
  }
}

// 模擬「附近地點推薦」：意外發現流程用座標找最近的假地點。
export function nearbyMockPlaces (lat, lng, limit = 3) {
  const dist = (p) => Math.hypot(p.lat - lat, p.lng - lng)
  return [...MOCK_PLACE_DB].sort((a, b) => dist(a) - dist(b)).slice(0, limit)
}
